import { render, staticRenderFns } from "./ComexMainBoard.vue?vue&type=template&id=2d742018&"
import script from "./ComexMainBoard.vue?vue&type=script&lang=js&"
export * from "./ComexMainBoard.vue?vue&type=script&lang=js&"
import style0 from "./ComexMainBoard.vue?vue&type=style&index=0&id=2d742018&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports